var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout layout--default",attrs:{"id":"app"}},[_c('announcements-bar'),_c('landing-header-bar'),_c('div',{attrs:{"id":"content"}},[_c('nuxt')],1),_c('landing-footer-bar',{staticClass:"legacy"}),_c('cookie-consent-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }